import { render, staticRenderFns } from "./ProfilBU.vue?vue&type=template&id=a67b2e26&scoped=true&"
import script from "./ProfilBU.vue?vue&type=script&lang=js&"
export * from "./ProfilBU.vue?vue&type=script&lang=js&"
import style0 from "./ProfilBU.vue?vue&type=style&index=0&id=a67b2e26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b2e26",
  null
  
)

export default component.exports